import { NotificationConfiguration } from '../notification.templates';

export const CR_APPROVAL_RATE_REACHED_TEMPLATE: NotificationConfiguration = {
  inapp: `Approval rate is reached`,
  email: {
    ctaKey: 'go_to_cr',
  },
};
